const APIStorage = {
  getItem: async (key) => {
    return JSON.stringify(window.userData);
  },

  setItem: async (key, item) => {
    try {
      const resp = await fetch('/profile/state', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: item,
      });
      if (!resp.ok) {
        throw new Error('save state request failed');
      }

      return;
    } catch (err) {
      console.log(err);
      throw err;
    }
  },

  removeItem: (key) => {
    console.log('removeItem', key);
  },
};

export default APIStorage;
